import { Factory } from '../../services/Factory';

namespace app.directives.controls {
  export interface ISplitterScope extends angular.IScope {
    panes: any[];
  }

  export interface ISplitterAttributes extends angular.IAttributes {
  }

  export interface IPaneScope extends angular.IScope {
  }

  export interface IPaneAttributes extends angular.IAttributes {
  }

  export class Pane implements angular.IDirective {
    public restrict: string = "E";
    public link: (scope: IPaneScope, element: angular.IAugmentedJQuery, attrs: IPaneAttributes) => void;
    public template: string;
    public scope = {minSize: '='};
    public transclude = true;

    constructor() {
      this.template = `<div class="split-pane{{index}}" ng-transclude></div>`;
      this.link = (scope: IPaneScope, element: angular.IAugmentedJQuery, attrs: IPaneAttributes) => {
        if (!scope.$parent.$parent.panes) {
          scope.$parent.$parent.panes = [];
        }

        scope.elem = element;
        if (scope.$parent.$parent.panes.length > 1)
          throw 'splitters can only have two panes';
        scope.$parent.$parent.panes.push(scope);
        scope.index = scope.$parent.$parent.panes.length;
      }
    }
  }

  export class Splitter implements angular.IDirective {
    public restrict: string = "E";
    public link: (scope: ISplitterScope, element: angular.IAugmentedJQuery, attrs: ISplitterAttributes) => void;
    public template: string;
    public scope = {orientation: "@"};
    public transclude = true;

    constructor($window: angular.IWindowService) {
      this.template = `<div class="split-panes {{orientation}}" ng-transclude></div>`;
      this.link = (scope: ISplitterScope, element: angular.IAugmentedJQuery, attrs: ISplitterAttributes) => {
        const handler = angular.element(`<div class="split-handler"></div>`);
        const pane1 = scope.panes[0];
        const pane2 = scope.panes[1];
        const vertical = scope.orientation == "vertical";
        const pane1Min = pane1.minSize || 0;
        const pane2Min = pane2.minSize || 0;
        let drag = false;

        pane1.elem.after(handler);

        const ownerDoc = angular.element(element[0].ownerDocument);

        ownerDoc.bind("mousemove", function (ev) {
          if (!drag) return;

          const bounds = element[0].getBoundingClientRect();
          let pos = 0;

          const pane1Inner = pane1.elem.children().first();
          const pane2Inner = pane2.elem.children().first();

          if (vertical) {
            const height = bounds.bottom - bounds.top;
            pos = ev.clientY - bounds.top;

            if (pos < pane1Min) return;
            if (height - pos < pane2Min) return;

            handler.css("top", pos + "px");
            pane1Inner.css("height", pos + "px");
            pane2Inner.css("top", pos + "px");

          } else {
            const width = bounds.right - bounds.left;
            pos = ev.clientX - bounds.left;

            if (pos < pane1Min) return;
            if (width - pos < pane2Min) return;

            handler.css("left", pos + "px");
            pane1Inner.css("width", pos + "px");
            pane2Inner.css("left", pos + "px");
          }
        });

        handler.bind("mousedown", e => {
          e.preventDefault();
          drag = true;
        });

        ownerDoc.bind("mouseup", () => drag = false);
      }
    }
  }

  frontendApp.directive("iioSplitter", ["$window", Factory.Create(Splitter)]).directive("iioPane", [Factory.Create(Pane)]);
}
